import React, { useCallback, useState, useContext } from 'react'
import styles from './CrmSettings.module.css'
import { useTranslation } from 'react-i18next'
import { LuLayoutDashboard, LuColumns2, LuTrash, LuPlus, LuRefreshCw } from "react-icons/lu";
import { LiaFilterSolid } from "react-icons/lia";
import { VscSymbolProperty } from "react-icons/vsc";
import { TbCirclesRelation } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { useSelector,useDispatch } from 'react-redux'
import ConfirmationModal from '../../UI/ConfirmationModal/ConfirmationModal';
import * as actions from '../../../store/actions/index'
import { syncCrmModules } from '../../../axios/requests/moduleReq'
import AlertContext from '../../../context/AlertModelContext/AlertModalContext'

const CrmSettings = (props) => {
    const [t] = useTranslation('crm')
    const navigate = useNavigate();
    const crmState = useSelector(state => state.crm)
    const loggedUser = useSelector(state => state.login)
    const [confirmationModal, setConfirmationModal] = useState({ show: false })
    const [syncLoading, setSyncLoading] = useState(false)
    const dispatch = useDispatch()
    const alertCtx = useContext(AlertContext)
    const manageCrmModuleSelectedObj = crmState.selectedCrmModule
    const moduleSelectionMode = crmState.moduleSelectionMode

    const onShowConfirmationModal = useCallback((titleKey, bodyKey, onConfirm, customDeleteBtnName) => {
        setConfirmationModal({
            show: true,
            titleKey,
            bodyKey,
            onConfirm,
            customDeleteBtnName
        })
    }, [])

    const deleteModule = useCallback(() => {
        if(!manageCrmModuleSelectedObj?._id) return console.log('Module not selected.')
        const moduleId = manageCrmModuleSelectedObj._id
        dispatch(actions.deleteModuleById(moduleId))
    }, [manageCrmModuleSelectedObj])

    const onDeleteModuleClickHandler = useCallback(() => {
        onShowConfirmationModal(
            t('Module deletion', { module: manageCrmModuleSelectedObj?.label }),
            t('Are you sure you want to delete this module? module deletion will delete all records and reletionships with other modules', { module: manageCrmModuleSelectedObj?.label }),
            () => {
                deleteModule()
                setConfirmationModal(() => ({ show: false }))
            }, t('Delete'))
    }, [manageCrmModuleSelectedObj])

    const onSyncCrmClickHandler = useCallback(async () => {
        setSyncLoading(true)
        alertCtx.showAlert('', <div style={{textAlign: 'center', padding: '20px'}}><div className="spinner-border" role="status"><span className="sr-only">Loading...</span></div></div>, 'sm')
        try {
            await syncCrmModules()
            alertCtx.showAlert(t('success'), t('CRM sync completed successfully.'), 'sm')
            // Reload modules after sync
            dispatch(actions.initCrmModule())
        } catch (e) {
            alertCtx.showAlert(t('fail'), t('CRM sync failed. Please try again.'), 'sm')
        } finally {
            setSyncLoading(false)
        }
    }, [alertCtx, t, dispatch])


    return (
        <ul className='ulsettings'>
            <li>
                <p className='liTitle liTitleFirst'>{t('Customer Relationship Management')}</p>
                {loggedUser?.permissionType === 1 && (
                    <p onClick={!syncLoading ? onSyncCrmClickHandler : undefined} className={`liSettings ${syncLoading ? 'liSettings-disabled' : ''}`}>
                        {t('Sync CRM')} <LuRefreshCw className={`${styles['setting-icon']} ${syncLoading ? styles['setting-icon--spin'] : ''}`} />
                    </p>
                )}
                <p onClick={() => navigate(`/crm/modules/create`)} className='liSettings' >{t('Add Module')} <LuPlus className={`${styles['setting-icon']}`} /></p>
                {/* <p className={`liSettings ${crmModuleDragEnabled && 'liSettings-active'}`} onClick={() => onModuleChangeLayoutClicked()}>{t('Module Layout')} <LuLayoutDashboard className={`${styles['setting-icon']} ${crmModuleDragEnabled && styles['setting-icon--active']}`} /></p> */}
            </li>
            {manageCrmModuleSelectedObj && moduleSelectionMode === 'select' && <li>
                <p />
                <p className='liTitle liTitleFirst'>{t('Module {{module}} managment', { module: t(manageCrmModuleSelectedObj?.label) })}</p>
                <p onClick={() => navigate(`/crm/${manageCrmModuleSelectedObj?.name}/settings/fields-managment`)} className='liSettings' >{t('Fields managment')} <VscSymbolProperty className={`${styles['setting-icon']}`} /></p>
                <p onClick={() => navigate(`/crm/${manageCrmModuleSelectedObj?.name}/settings/module-layout`)} className='liSettings' >{t('Module layout')} <LuLayoutDashboard className={`${styles['setting-icon']}`} /></p>
                <p onClick={() => navigate(`/crm/${manageCrmModuleSelectedObj?.name}/settings/relationships`)} className='liSettings' >{t('Module Relationships')} <TbCirclesRelation className={`${styles['setting-icon']}`} /></p>
                {/* <p onClick={() => navigate(`/crm/${manageCrmModuleSelectedObj?.name}/settings/grid-columns`)} className='liSettings' >{t('Grid columns')} <LuColumns2 className={`${styles['setting-icon']}`} /></p> */}
                {/* <p onClick={() => navigate(`/crm/${manageCrmModuleSelectedObj?.name}/settings/grid-filters`)} className='liSettings' >{t('Grid filters')} <LiaFilterSolid className={`${styles['setting-icon']}`} /></p> */}
                {/* {manageCrmModuleSelectedObj.isDeletable && <p className='liSettings' onClick={onDeleteModuleClickHandler}>{t('Remove Module')} <LuTrash className={`${styles['setting-icon']}`} /></p>} */}
            </li>
            }
            <ConfirmationModal
                {...confirmationModal}
                onHide={() => setConfirmationModal(() => ({ show: false }))}
            />
        </ul>
    )
}

export default CrmSettings